import { Box, Typography } from '@mui/material';

const EmptyCard = (props) => {
  return (
    <Box
      sx={{
        width: '100%',
        minHeight: '200px',
        border: '2px solid white',
        borderRadius: '15px',
        backgroundColor: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Typography
        align="center"
        sx={{ fontSize: '1.25rem', fontWeight: 'semibold', color: '#737373' }}
      >
        {props.text}
      </Typography>
    </Box>
  );
};

export default EmptyCard;
